var works = function() {
	var $grid = document.querySelector('.works-list');
  
    /*var msnry = new Masonry( $grid, {
      // set itemSelector so .grid-sizer is not used in layout
      itemSelector: '.portfolio-item-wrapper',
      // use element for option
      columnWidth: '.portfolio-item-wrapper',
      gutter: 0,
    });
    */
  
    var isotope = new Isotope( $grid, {
      itemSelector: '.portfolio-item-wrapper',
      layoutMode: 'masonry',
      columnWidth: '.portfolio-item-wrapper',
      gutter: 0
    });
}

jQuery("body").on("contextmenu", "img", function(e) {
  return false;
});


jQuery(window).load(function(){
  
	works();
  
  
  	var $grid = $('.works-list');
  
    var collection = location.href.split('/')[location.href.split('/').length - 1];
  
  	console.log(collection);
      

    $(".toolbar-item").each(function(){
      var item = $(this);

      if(item.attr('data-collection') === collection){
        $(this).addClass('selected');
      }
      

    })
    
  
    $(function() {
      
      $(".toolbar-item").click(function(){
		$(".toolbar-item").removeClass('selected');
        $(this).addClass('selected');      
      });
			
      $(".fil-cat").click(function(){ 

        $(".fil-cat").removeClass('selected');
        $(this).addClass('selected');
        
        var filterValue = $( this ).attr('data-filter');
        // use filterFn if matches value
        
        $grid.isotope({ filter: '.' + filterValue });

        //$(".works-list").fadeTo(100, 0.1);
        //$(".works-list div").not("."+selectedClass).fadeOut().removeClass('scale-anm');

        /*setTimeout(function() {
          $("."+selectedClass).fadeIn().addClass('scale-anm');
          $(".works-list").fadeTo(300, 1);
        }, 300); 
		*/
      });
    });
  
  	var sliderItems = $('.product-item a');
  
  	sliderItems.each(function(){
      $this = $(this);
      
      $this.loupe({
        width: 200, // width of magnifier
        height: 200, // height of magnifier
        loupe: 'product-item-loupe' // css class for magnifier
      });

  	})
  
  	

});

var burger = $('.menu-mobile');
var header = $('.header-wrapper');

burger.click(function(){
  header.toggleClass('opened');
  $(this).toggleClass('opened');
});

var slider = tns({
  container: '.product-slide',
  items: 1,
  controls: false,
  slideBy: 'page',
  autoplay: false,
  mouseDrag: true,
  gutter: 0
});

var index = jQuery('.slider-counter .index');
var total = jQuery('.slider-counter .total');

console.log('slider', slider.getInfo());

index.text(slider.getInfo().slideBy);
total.text(slider.getInfo().slideCount);

jQuery('.prev-slide').click(function(){
	slider.goTo('prev');
	jQuery('.slider-counter .index').text(slider.getInfo().navCurrentIndex + 1);
});

jQuery('.next-slide').click(function(){
	slider.goTo('next');
  	jQuery('.slider-counter .index').text(slider.getInfo().navCurrentIndex + 1);
})
